module.exports = __webpack_public_path__ + "static/img/1.ac478587.jpg";